import { ListPillItem } from "@search/api/types";
import NumberListFilter from "@search/store/filters/primitive/NumberListFilter";

class PriceFilter extends NumberListFilter {
  constructor(value: Array<number>) {
    super({ name: "price", value });
  }

  toParam() {
    return this.value.join("-");
  }

  toPills(): Array<ListPillItem> {
    const pills: Array<ListPillItem> = [];
    const { value } = this;

    if (value.length) {
      pills.push({
        key: `${value.map((v) => `£${v}`).join(" - ")}`,
        name: this.name,
      });
    }

    return pills;
  }
}

export default PriceFilter;
export { PriceFilter };
